import { AlertLineReportStatusDTO } from "src/models/alert-line-report-status/alert-line-report-status-dto";
import { AlertLineReportStatusSTO } from "src/models/alert-line-report-status/alert-line-report-status-sto";
import { BaseApiService } from "../base";

export class AlertLineReportStatusApiService extends BaseApiService<
  AlertLineReportStatusDTO,
  AlertLineReportStatusSTO
> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/GetAlertLineReportStatuses",
      saveItemsPath: "/SaveAlertLineReportStatuses",
    });
  }
}
